import React, { memo, useCallback } from "react";

const InvoiceCard = ({
  data,
  onPendingClick
}) => {

  // ==========================================
  // STABLE CLICK HANDLER
  // ==========================================

  const handleClick = useCallback(
    (type) => {

      console.log(
        "Invoice Card Click =>",
        type
      );

      if (onPendingClick) {
        onPendingClick(type);
      }

    },
    [onPendingClick]
  );


  // ==========================================
  // REUSABLE CARD RENDERER
  // ==========================================

  const renderCard = (
    bg,
    icon,
    value,
    label,
    clickable = false,
    colClass = "col-xl-3 col-xxl-6 col-sm-6",
    type = null,
    extraContent = null
  ) => (

    <div className={colClass}>

      <div
        className={`card ${bg} invoice-card`}
        onClick={
          clickable
            ? () => handleClick(type)
            : undefined
        }
        style={
          clickable
            ? {
                cursor: "pointer"
              }
            : {}
        }
      >

        <div className="card-body d-flex">

          {/* ICON */}

          <div className="icon me-3">

            <i
              className={`bi ${icon} fs-4 text-white`}
            />

          </div>


          {/* CONTENT */}

          <div className="flex-grow-1">

            <h2 className="text-white invoice-num">

              {value ?? 0}

            </h2>


            <span className="text-white fs-18">

              {label}

            </span>


            {extraContent}

          </div>

        </div>

      </div>

    </div>

  );


  return (
    <>

      {/* ========================================== */}
      {/* PAYMENT ACTION DASHBOARD */}
      {/* ========================================== */}

      {renderCard(
        "bg-dark",
        "bi-cash-stack",

        data?.totalPaymentPending || 0,

        "Payment Action Dashboard",

        true,

        "col-xl-3 col-xxl-6 col-sm-6",

        "payment"
      )}


      {/* ========================================== */}
      {/* TRANSFER */}
      {/* ========================================== */}

      {renderCard(
        "bg-info",
        "bi-truck",

        data?.totalSubmittedTransfer,

        "Pending Transfer Orders"
      )}


      {/* ========================================== */}
      {/* MTN */}
      {/* ========================================== */}

      {renderCard(
        "bg-secondary",
        "bi-bag-plus",

        data?.approvedMtn,

        "Pending Material Transfer Note"
      )}


      {/* ========================================== */}
      {/* MIV */}
      {/* ========================================== */}

      {renderCard(
        "bg-secondary",
        "bi-cart-dash",

        data?.totalSubmittedMiv,

        "Pending Material Issue Voucher",

        false,

        "col-xl-3 col-xxl-6 col-sm-6"
      )}

    </>
  );
};


export default memo(InvoiceCard);